<script setup lang="ts">
import PBadge, { type PBadgeProps } from '@ui/components/core/p-badge/PBadge.vue';
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@ui/lib/utils.js';
import { type PIconBadgeVariants, pIconBadgeVariants } from './index.js';

interface PIconBadgeProps extends Omit<PBadgeProps, 'rounded'> {
    size?: PIconBadgeVariants['size'];
}

const props = defineProps<PIconBadgeProps>();

const delegatedProps = reactiveOmit(props, 'class', 'size');
</script>

<template>
    <PBadge :class="cn(pIconBadgeVariants({ size }), 'aspect-square', props.class)" v-bind="delegatedProps">
        <slot />
    </PBadge>
</template>
